import '@stoplight/elements/styles.min.css';

import { API } from '@stoplight/elements';
import constants from '../constants';
import React, { useContext } from 'react';

import { GlobalContext } from '../context';
import {useWindowSize} from "../UseWindowSize";

export const Api: React.FC = () => {
  const { apiDescriptionUrl } = useContext(GlobalContext);
  const size = useWindowSize();
  let spec = constants.specs.find(o => o.value === apiDescriptionUrl);
  if (!spec){
    return <div/>;
  }
  // @ts-ignore
  const isMobile = size && size.width < 950;
  if (isMobile){
    return <div style={{padding: "5px"}}>
       <API basePath="/" apiDescriptionUrl={apiDescriptionUrl} router="hash" hideSchemas={true} layout="stacked" />
    </div>    
  }
  else {
    return <API basePath="/" apiDescriptionUrl={apiDescriptionUrl} router="hash" hideSchemas={true} layout="sidebar" />
  }
};

